import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userAPI } from '../services/api';
import '../styles/Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await userAPI.getProfile();
      setUser(response.data);
    } catch (err) {
      setError('Failed to load profile');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard">
        <header className="dashboard-header">
          <h1>MSN Messenger</h1>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </header>

        {error && <div className="error">{error}</div>}

        <div className="dashboard-content">
          <div className="sidebar">
            <div className="user-profile">
              {user?.avatar_url && <img src={user.avatar_url} alt={user.username} />}
              <div className="user-info">
                <h3>{user?.username}</h3>
                <p className={`status ${user?.status}`}>{user?.status || 'offline'}</p>
                {user?.status_message && <p className="status-message">{user.status_message}</p>}
              </div>
            </div>

            <nav className="dashboard-nav">
              <button className="nav-item active">Contacts</button>
              <button className="nav-item">Friend Requests</button>
              <button className="nav-item">Recent</button>
            </nav>
          </div>

          <main className="main-content">
            <div className="empty-state">
              <h2>Welcome to MSN Messenger!</h2>
              <p>Your email-based authentication is complete.</p>
              <p>Next features coming: Real-time messaging, contact management, and more.</p>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
